import { lazy } from 'react';
import { authRoles } from 'app/auth';

const StaffSuppliersPage = lazy(() => import('./people/StaffSuppliersPage'));
const StaffEmployeesPage = lazy(() => import('./people/StaffEmployeesPage'));
const StaffCustomersPage = lazy(() => import('./people/StaffCustomersPage'));

/**
 * Staff-only people lists live here. Do not register `orders`, `quotes`, or
 * `rfqs` here: a staff-only path listed first would 403 customers before they
 * reach StaffListGate on AllAppConfig / StaffAppConfig.
 *
 * Suppliers, Employees, and Customers are staff-only already, so they can sit here.
 * Products stay on AllAppConfig behind StaffProductsGate under `staff/products/`
 * (shared with customer cart; not a people list).
 */

const StaffListsAppConfig = {
  settings: {
    layout: {},
  },
  auth: authRoles.staff,
  routes: [
    {
      path: 'suppliers',
      element: <StaffSuppliersPage />,
    },
    {
      path: 'employees',
      element: <StaffEmployeesPage />,
    },
    {
      path: 'customers',
      element: <StaffCustomersPage />,
    },
  ],
};

export default StaffListsAppConfig;
